import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Loading, Modal, Text, useModal, useRequestStatus} from '@treatwell/ui';
import {fetchInfoPageContent} from '../../../../../api/rainbow';
import type {InfoPageType} from '../../../../../types/rainbow-api/InfoPageOutput';
import styles from './LegalLinkModal.module.css';

type Props = {
  pageType: InfoPageType;
  label: string;
  'data-cy'?: string;
};

export const LegalLinkModal = ({pageType, label, 'data-cy': dataCy}: Props) => {
  const {t} = useTranslation();
  const {openModal, modalProps, setTriggerRef} = useModal({title: label});
  const {
    setStatusPending,
    setStatusFulfilled,
    setStatusRejected,
    isStatusFulfilled,
  } = useRequestStatus();
  const [content, setContent] = useState('');
  const [title, setTitle] = useState<string | undefined>(undefined);

  useEffect(() => {
    setStatusPending();
    fetchInfoPageContent([pageType])
      .then(([page]) => {
        setContent(page?.content ?? '');
        setTitle(page?.title);
        setStatusFulfilled();
      })
      .catch(() => setStatusRejected());
  }, [pageType, setStatusFulfilled, setStatusPending, setStatusRejected]);

  return (
    <>
      <button
        type="button"
        ref={setTriggerRef}
        className={styles.button}
        onClick={openModal}
        data-cy={dataCy}
      >
        <Text type="captionHeavy" as="span" className={styles.label}>
          {label}
        </Text>
      </button>
      <Modal {...modalProps}>
        <Modal.Header closeLabel={t('register.legalModal.close')}>
          <Text as="h2" type="lgHeader">
            {title ?? label}
          </Text>
        </Modal.Header>
        <Modal.Body>
          {isStatusFulfilled ? (
            <div dangerouslySetInnerHTML={{__html: content}} />
          ) : (
            <Loading />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
